<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width building-and-room-page"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.Buildings & Rooms')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <div class="mb-20 section-title">
          <span class="mr-20">{{
            $t('text.organisation').toLowerCase() | firstLetterCapitalize
          }}</span>
          <span>{{ $store.getters[`user/selecteOrganisationName`] }}</span>
        </div>
        <BuildingAndRoomStructure />
      </div>
    </div>
  </div>
</template>

<script>
import BuildingAndRoomStructure from '@/components/manage/building/BuildingAndRoomStructure.vue'
export default {
  components: {
    BuildingAndRoomStructure
  }
}
</script>
